
import Dashboard from './init-payments';
import DebitAccountList from './debit-account-list/debit-account-list';
import PymtDomNew from './domestic-payment-form/payment-form';
import paymentDestination from './payment-destination/payment-destination';
import PaymentSummary from './payment-summary';
import PymtBenefAdd from './payment-destination/payment-add-beneficiary';
import PaymentFilter from './init-payments/payment-filter';
import paymentsLoader from './payment-loading';
import PaymentTemplate from './payment-template';

export default{
	Dashboard,
	DebitAccountList,
	PymtDomNew,
	paymentDestination,
	PaymentSummary,
	PymtBenefAdd,
	paymentsLoader,
	PaymentFilter,
	PaymentTemplate
}
